import { render, staticRenderFns } from "./GSelectorForm.vue?vue&type=template&id=2b190ed5&"
import script from "./GSelectorForm.vue?vue&type=script&lang=ts&"
export * from "./GSelectorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports